import { render, staticRenderFns } from "./EditRules.vue?vue&type=template&id=4a5e18bf&scoped=true"
import script from "./EditRules.vue?vue&type=script&lang=js"
export * from "./EditRules.vue?vue&type=script&lang=js"
import style0 from "./EditRules.vue?vue&type=style&index=0&id=4a5e18bf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5e18bf",
  null
  
)

export default component.exports